import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import styled from 'styled-components';
import appStore from '../assets/svg/app-store.svg';
import googlePlay from '../assets/svg/google-play.svg';
import footerShape from '../assets/svg/footer-shape.svg';
import withContentfulTag from '../utils/withContentfulTag';
import { contentfulPropTypes } from '../propTypes';

const StyledContainer = styled(Container)`
  background: url(${footerShape}) no-repeat top center/cover;
  position: absolute;
  z-index: 1000;
`;

const DownloadCTA = ({ contentful, error, loading, fetched }) =>
  !loading &&
  fetched && (
    <StyledContainer fluid className="app-cta-space">
      <Row>
        <Col className="text-center p-5 p-sm-3 p-md-3">
          <Container fluid="xl">
            <Row className="p-xl-3 p-lg-3 p-md-2 p-sm-1 mb-3">
              <Col>{contentful?.title}</Col>
            </Row>
            <Row className="p-xl-3 p-lg-3 p-md-2 p-sm-1">
              <Col className="text-right">
                <a href={contentful?.appStoreUrl}>
                  <img src={appStore} alt="Download from the App Store" />
                </a>
              </Col>
              <Col className="text-left">
                <a href={contentful?.playStoreUrl}>
                  <img src={googlePlay} alt="Download from the Play Store" />
                </a>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </StyledContainer>
  );

DownloadCTA.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  DownloadCTA,
  'web_app_download_cta',
  'webAppDownloadBlock',
);
